import { apiClient } from '@/shared/api/axios-instance';
import type { CreateAdminRequest, UpdateAdminRequest } from '../types/admin.types';

class AdminsService {
    async getAdmins() {
        const response = await apiClient.get('/admin/admins');
        return response.data;
    }

    async getRoles() {
        const response = await apiClient.get('/admin/roles');
        return response.data;
    }

    async createAdmin(data: CreateAdminRequest) {
        const response = await apiClient.post('/admin/admins', data);
        return response.data;
    }

    async updateAdmin(id: string, data: UpdateAdminRequest) {
        const response = await apiClient.put(`/admin/admins/${id}`, data);
        return response.data;
    }

    async deleteAdmin(id: string) {
        const response = await apiClient.delete(`/admin/admins/${id}`);
        return response.data;
    }

    async disableAdmin(id: string) {
        const response = await apiClient.post(`/admin/admins/${id}/disable`);
        return response.data;
    }

    async enableAdmin(id: string) {
        const response = await apiClient.post(`/admin/admins/${id}/enable`);
        return response.data;
    }

    async resetMfa(id: string, reason: string) {
        const response = await apiClient.post(`/admin/admins/${id}/reset-mfa`, { reason });
        return response.data;
    }

    async getWhitelistedIps() {
        const response = await apiClient.get('/admin/ips');
        return response.data;
    }

    async addWhitelistedIp(data: { ip_address: string, label?: string }) {
        const response = await apiClient.post('/admin/ips', data);
        return response.data;
    }

    async removeWhitelistedIp(id: number) {
        await apiClient.delete(`/admin/ips/${id}`);
    }
}

export const adminsService = new AdminsService();
